import { VMBuilder } from "../../../commons/base/providers/builder";
import MenuPackagingViewModel from "../view_models/menu_packaging_view_model";

interface MenuPackagingRowProps {
    item: {
        id: number;
        itemId: number;
        itemMaterialCode: string;
        itemName: string;
        packagingId: number;
        packagingName: string;
        packagingIsActive: boolean;
        quantity: number;
    };
    index: number;
    onEditClick: (id: number) => void;
}

const MenuPackagingRow: React.FC<MenuPackagingRowProps> = ({
    item,
    index,
    onEditClick,
}) => {
    return (
        <VMBuilder<MenuPackagingViewModel>>
            {(vm) => (
                <tr className="hover:bg-indigo-100">
                    <td className="border border-slate-700 p-2">{index + 1}</td>
                    <td className="border border-slate-700 p-2">
                        {item.itemMaterialCode}
                    </td>
                    <td className="border border-slate-700 p-2">
                        {item.itemName}
                    </td>
                    <td className="border border-slate-700 p-2">
                        {item.packagingName}{" "}
                        {item.packagingIsActive ? (
                            ""
                        ) : (
                            <span className="text-red-500 font-bold">
                                {" "}
                                (DISCONTINUE)
                            </span>
                        )}
                    </td>
                    <td className="border border-slate-700 p-2">
                        {item.quantity}
                    </td>
                    <td className="border border-slate-700 p-2">
                        {/* EDIT */}
                        <button
                            className="bg-violet-200 px-2 py-1 rounded hover:bg-violet-400"
                            title="Edit"
                            onClick={() => {
                                vm.loadDetail(
                                    item.id,
                                    item.itemId,
                                    item.packagingId,
                                    item.quantity
                                );
                            }}
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke-width="1.5"
                                stroke="currentColor"
                                className="size-6"
                            >
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10"
                                />
                            </svg>
                        </button>

                        {/* DELETE */}
                        <button
                            className="bg-red-200 ml-2 px-2 py-1 rounded hover:bg-red-400"
                            title="Delete"
                            onClick={() => {
                                if (
                                    window.confirm(
                                        `Delete menu packaging ${item.itemName}?`
                                    )
                                ) {
                                    vm.deleteMenuPackaging(item.id);
                                }
                            }}
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke-width="1.5"
                                stroke="currentColor"
                                className="size-6"
                            >
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
                                />
                            </svg>
                        </button>
                    </td>
                </tr>
            )}
        </VMBuilder>
    );
};

export default MenuPackagingRow;
